import _ from 'lodash'
import { GLOBAL_CONTEXT } from '../utils'

const appPortalUrlFromContext = _.get(GLOBAL_CONTEXT, 'appPortalUrl', '/')
const appPortalUrl = (state = appPortalUrlFromContext, action) => {
  switch (action.type) {
    case 'SET_ENTITLED_APPS':
      return _.get(_.find(action.apps, { name: 'App Portal' }), 'url', appPortalUrlFromContext)
    default:
      return state
  }
}

export default appPortalUrl
